import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";
import "./qmsAdmin.css";
import QmsAdminCmtCategories from "./QmsAdminCmtCategories";
import QmsAdminCmtQmsFrameworkChanges from "./QmsAdminCmtQmsFrameworkChanges";
import QmsAdminCmtStages from "./QmsAdminCmtStages";
import QmsAdminCmtWorkflows from "./QmsAdminCmtWorkflows";

export default function QmsAdminCmtMain(props) {
  const { divisionId, tabId } = props;

  const [selectedSection, selectSection] = useState("categories");

  const renderCmtMenu = () => (
    <ul className="list-group pointer-cursor">
      <li
        className={`list-group-item qms-admin__submenu--item ${
          selectedSection === "categories" && "active"
        }`}
        onClick={() => selectSection("categories")}
      >
        <FontAwesomeIcon icon="layer-group" className="fa-fw mr-2" />
        Input Categories
      </li>
      <li
        className={`list-group-item qms-admin__submenu--item ${
          selectedSection === "stages" && "active"
        }`}
        onClick={() => selectSection("stages")}
      >
        <FontAwesomeIcon icon="network-wired" className="fa-fw mr-2" />
        Preset Stages
      </li>
      <li
        className={`list-group-item qms-admin__submenu--item ${
          selectedSection === "workflows" && "active"
        }`}
        onClick={() => selectSection("workflows")}
      >
        <FontAwesomeIcon icon="code-branch" className="fa-fw mr-2" />
        Stage Workflows
      </li>
      <li
        className={`list-group-item qms-admin__submenu--item ${
          selectedSection === "qmsFrameworkChanges" && "active"
        }`}
        onClick={() => selectSection("qmsFrameworkChanges")}
      >
        <FontAwesomeIcon icon="stroopwafel" className="fa-fw mr-2" />
        QMS Framework Change Types
      </li>
    </ul>
  );

  return (
    <>
      <h3 className="text-muted">Change Management Tracker</h3>
      <hr className="my-2" />
      <div className="d-flex flex-row w-100">
        <div className="flex-column pr-3 border-right qms-admin__submenu">
          {renderCmtMenu()}
        </div>
        <div className="flex column pl-3 w-100">
          {selectedSection === "categories" ? (
            <QmsAdminCmtCategories divisionId={divisionId} />
          ) : selectedSection === "stages" ? (
            <QmsAdminCmtStages divisionId={divisionId} />
          ) : selectedSection === "workflows" ? (
            <QmsAdminCmtWorkflows divisionId={divisionId} tabId={tabId} />
          ) : selectedSection === "qmsFrameworkChanges" ? (
            <QmsAdminCmtQmsFrameworkChanges divisionId={divisionId} />
          ) : (
            "Select from the submenu."
          )}
        </div>
      </div>
    </>
  );
}
